import api, { baseURL } from "../../../../utils/api"

export const getNewClients = (page, limit, search = "") =>{
	return api.get(`${baseURL}/user/newclients?page=${page}&size=${limit}&search=${search}`);
}

export const approveClient = (client, isSwitchAccount = false, details = {}) =>{
	return api.post(`${baseURL}/auth/approveuser`, {id: client, isSwitchAccount, ...details });
}

export const declineClient = (client) =>{
	return api.post(`${baseURL}/auth/declineuser`, {id: client});
}

export const deleteClient = (clientId) =>{
	return api.delete(`${baseURL}/user/deleteuser?id=${clientId}`);
}